module.exports = __webpack_public_path__ + "static/ks_logo-06266a4d2503370b4870bd4ae5d5e8d3.svg";